var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-progress',_vm._b({attrs:{"percentage":_vm.getPercentage}},'el-progress',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }